export default __webpack_public_path__ + "static/media/calculator.d172eb33.svg";